import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  postUrl(payload) {
    const kycId = payload?.kycId || payload?.id
    console.log("🚀 ~ kycId:", kycId)
    if (!kycId) {
      throw new Error('kycId is required for deleting KYC')
    }

    return buildApiUrl(ADMIN_ENDPOINTS.KYC_DELETE, {
      pathParams: { kycId }
    })
  },

  method: 'POST',

  format(payload = {}) {
    return {}
  },

  parse(raw = {}) {
    if (!raw.success) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Failed to delete KYC',
        data: null,
      }
    }

    return {
      statusCode: 200,
      message: 'KYC deleted successfully',
      data: raw?.data || null,
    }
  },
}
